import axios from 'axios';

export async function client(endpoint, { body, ...customConfig } = {}) {
	console.log('start request', endpoint, body, customConfig);
	const headers = { 'Content-Type': 'application/json' };

	const config = {
		method: body ? 'POST' : 'GET',
		url: `${process.env.REACT_APP_API_BASE_URL}${endpoint}`,
		auth: {
			username: process.env.REACT_APP_API_USER,
			password: process.env.REACT_APP_API_PASSWORD,
		},
		...customConfig,
		headers: {
			...headers,
			...customConfig.headers,
		},
	};

	if (body) {
		// config.body = JSON.stringify(body);
		config.data = body;
	}

	console.log('request config: ', config);

	let data;
	try {
		const response = await axios(
			config,
		);

		console.log('API RESPONSE', response);

		if (checkApiResponseStatus(response) === true) {
			return response;
		}

		return Promise.reject(getApiErrorMessage(response));
	} catch (err) {
		return Promise.reject(err.message ? err.message : data);
	}
}

client.get = (endpoint, customConfig = {}) => client(endpoint, { ...customConfig, method: 'GET' });

client.post = (endpoint, body, customConfig = {}) => client(endpoint, { ...customConfig, body });

const checkApiResponseStatus = (response) => response?.data?.status === true || false;

const getApiErrorMessage = (response) => response?.data?.error || null;
